<template>
  
  <div class="login-bg" v-if="verify && ($isPc || limitDeviceSizeYn)">
    <validation-observer ref="loginObserver">
      <div class="bg-img"></div>
      <div class="login-box" >
          <img alt="logo" src="@/assets/login/logo.jpg" style="height: 110px" />
          <div class="login-title">業務員入口網</div>
          <v-flex sm12>
            <v-layout row>
              <v-flex>
                <validation-provider v-slot="{errors}"
                                    vid="branCodeRold"
                                    name="系統角色"
                                    rules="required">
                  <div id="branCodeID"
                      class="menu-has-id">
                    <v-autocomplete v-model="userRole"
                                    return-object
                                    :items="userRoleList"
                                    :search-input.sync="userRoleSync"
                                    item-text="roleName"
                                    maxlength="20"
                                    hide-no-data
                                    no-data-text=""
                                    style="width:100%;margin-bottom: 30px;"
                                    class="d-in-block"
                                    placeholder="系統角色"
                                    :error-messages="errors"
                                    outline></v-autocomplete>
                  </div>
                </validation-provider>

              </v-flex>
            </v-layout>
          </v-flex>
          <btn-lg-primary class="login-btn"
                          @click="rmwloginHandler">確定</btn-lg-primary>
        </div>
      </validation-observer>
    </div>
    <!--顯示 用手機錯誤訊息 -->
    <div v-else-if="!verify && !$isPc && !limitDeviceSizeYn" style="display:block;
              margin:50px auto;
              text-align: center;
              font-size: 18px;"> {{$isNotPcMsg}}</div>
<!-- 顯示 連結錯誤訊息 -->
    <base-error-page v-else :errorMsg="message"  ></base-error-page>
</template>
<script>
import api from '@/api';
import BaseErrorPage from '@/components/Base/BaseErrorPage';
import store from '@/store';
import isEmpty from "lodash/isEmpty";
import { createNamespacedHelpers } from "vuex";
const qs = require('qs')
const { mapActions } = createNamespacedHelpers("user");
export default {
  components: { BaseErrorPage },
  data () {
    return {
      message: null, // 錯誤訊息
      verify: false, // 顯示區域
      userRoleList: [], // 角色選單
      userRole: null, // 選取角色
      userRoleSync: null,
      limitDeviceSizeYn: null, // 限制使用者裝置尺寸
    }
  },
  beforeRouteEnter (to, from, next) {
    const query = to.query
    let params = {
      from: query.from,
      param: query.param.replaceAll(" ", "+") // 加密字串被轉碼 所以取代還原
    }
    api.post('/rmw/rmwLogin', qs.stringify(params), { //導頁進入rmw login 驗證
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        validateStatus: function (status) {
          return true
        }
      })
      .then(r => {
        sessionStorage.setItem('randomPageId', r.data.randomPageId)
        if (r.status === 200) {
          store.dispatch('user/fetchUserInfo').then(() => {
            store.dispatch('user/featchBranCodeRole').then((r2) => {
              if (r2.data && r2.data.length === 1) { // 只有一個角色，直接跳轉
                  store.dispatch('user/changeBranCodeRole',{
                    branCode: r2.data[0].branCode,
                    roleCode: r2.data[0].roleCode,
                  }).then((r) => {
                    let vm = this;
                    if(isEmpty(r.data)) { //沒有錯誤訊息 跳轉
                        next({
                          replace: true,
                          path: '/',
                          name: 'home',
                          params: {  }
                        })
                    } else{
                      next(vm =>{ // 顯示錯誤訊息
                        vm.verify = false
                        vm.message = r.data
                      })
                    }
                  });
                } else { //多角色 進入角色選擇頁面
                  next(vm =>{
                    vm.verify = true
                    vm.userRoleList =  r2.data
                  })
                }
              })
            })
        } else if (r.status === 401) {//顯示錯誤訊息
            next(vm =>{
              vm.message = r.data.message
          })
        }
      })
  },
  created () {
    let vm = this
    const $htmlScroll = document.documentElement
    $htmlScroll.className = ''

    // 限制使用者裝置尺寸  Y:不能用手機 N:可以用手機
    this.$store.dispatch('common/fetchCellphoneSwitch').then(r => {
      this.limitDeviceSizeYn = r.data === 'N'
      console.log(this.limitDeviceSizeYn)
    })
  },
  watch: {
    userRoleSync (v) {
      !v && (this.userRole = null)
    },
  },
  methods: {
    ...mapActions([
      "fetchUserInfo",
      "featchBranCodeRole",
      "changeBranCodeRole",
    ]),
    rmwloginHandler () { //選擇角色
      this.$doValidate('loginObserver').then(isValid => {
        if (isValid) {
          this.changeBranCodeRole({
            branCode: this.userRole.branCode,
            roleCode: this.userRole.roleCode,
          }).then((r) => {
            if(isEmpty(r.data)) {
              this.fetchUserInfo().then((response) => {
                this.$router.replace("home");
              });
            } else {
              this.$alert(r.data, yn => {  // 未具備壽險登錄證字號或已註銷登錄，無法使用行動投保系統
                this.$store.dispatch("user/logout");
                window.location.reload()
              })
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.bg-img {
  background-image: url('../../../assets/login/login_bg.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100%;
  width: 100%;
}

.login-box {
  width: 400px;
  border-radius: 15px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.21);
  background-color: #ffffff;
  position: absolute;
  right: 0%;
  top: 50%;
  transform: translate(-10%, -50%);
  padding: 0px 30px 10px;
}

.login-btn {
  padding: 10px 70px;
  border-radius: 50px;
  background: linear-gradient(to bottom, #0940c5, #11336a 100%);
  border: 2px solid #11336a;
  margin-top: 15px;
  border-color: #11336a!important;
}
.login-bg {
  width: 100%;
  height: 100%;
}
.login-title {
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 2px;
  padding-top: 10px;
  border-top:1px solid #eee;
  margin-bottom: 15px;
  color: #757171;

}

</style>